import React, { Suspense, useState, useEffect, useRef } from "react";
import Drawer from 'react-modern-drawer';
import gridTemplateService from "./gridTemplateService";
import { CommonUtilities } from "commonUtils";
import AllSplitBox from "./SplitInfo";
import Svg_icon from "components/flags/svg_icon";
import Pagination from "components/Common/newPagination";

export default function ContactSplitsListingBox(param: any) {

    let [allSplitStatus, setAllSplitStatus] = useState(false);
    let [contractSplitRow, setContractSplitRow] = useState(0);
    let [saveAlertInvoice, setsaveAlertInvoice] = useState(false);
    let [splitsListingData, setSplitListingData] = useState<any>([]);
    let [clientZone, setClientZone] = useState<any>([]);
    let [activeZone, setActiveZone] = useState<any>([]);
    let [searchFor, setsearchFor] = useState("")
    let [selectSplit, setSelectSplit] = useState<any>([]);

    var payload = { type: 'kontactAsset', pageNumber: 1, pageSize: 10, Assettype: 'Split', contactCode: 'PRSO298144', zone: activeZone?.zoneID ?? 'US', searchFor: searchFor }
    const splitsListing = (zone: any) => {
        activeZone = zone
        setActiveZone(activeZone);

        gridTemplateService.SplitsListing(payload).then((res: any) => {
            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
            splitsListingData = CommonUtilities.relativeDataRemapping(res.data, res.headers.original)
            setSplitListingData(CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
            contractSplitRow = res.totalRows
            setContractSplitRow(contractSplitRow)
        })
    }

    useEffect(() => {

        console.log(param)
        if (param.contactSplitOpen) {
            gridTemplateService.getAllClientZones({ isAllZone: false }).then((respond: any) => {
                clientZone = respond;
                setClientZone(clientZone)
                if (respond[0]) {
                    activeZone = respond[0];
                    setActiveZone(activeZone)
                    splitsListing(activeZone)
                }
            })
        }

    }, [param.contactSplitOpen]);

    const allSplit = () => {
        allSplitStatus = true;
        setAllSplitStatus(allSplitStatus)
    }

    const closContactSplit = () => {
        param.closContactSplit()
    }

    const closContactLODSplit = () => {
        allSplitStatus = false
        setAllSplitStatus(allSplitStatus)
    }

    const paginationContractSplit = (e: any) => {
        payload.pageNumber = e.pageNumber;
        payload.pageSize = e.pageSize;
        splitsListing(activeZone);
    }

    return (
        <Drawer open={param.contactSplitOpen} onClose={closContactSplit} direction='right' className='react-drawer full-height-vh allowHscroll allowVscroll ' size={1200}>

            <div className="ws-7 box pull-right landing">

                <div className="ws-12">
                    <div className="pr ws-12">

                        <div className="box-header-main well">
                            <h2 className="ws-10">Contact Splits Listing</h2>
                        </div>

                        <div className="ws-12 pm pts">
                            <fieldset className="scheduler-border p0 m0">
                                <legend className="scheduler-border">
                                    <h2>
                                        <i className="fa fa-sticky-note-o"></i> Contact Info
                                    </h2>
                                </legend>

                                <div className="ws-12">

                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label ws-4 text-right pr">  Contact Code :  </label>
                                            <div className="label-entries ws-8 ">  {param?.code?.kontactCode}  </div>
                                        </div>
                                    </div>

                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label ws-4 text-right pr">  Contact Name :  </label>
                                            <div className="label-entries ws-8 "> {param?.code?.kontactDisplay} </div>
                                        </div>
                                    </div>

                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label ws-4 text-right pr"> Email :  </label>
                                            <div className="label-entries ws-8 ">{param?.code?.emailAdd1}</div>
                                        </div>
                                    </div>
                                </div>

                            </fieldset>
                        </div>

                        <div className="ws-12 mt pm">
                            <div className="ws-12 pm box">
                                <div className="ws-7 pt ">
                                    <input type="text" value={searchFor} onChange={(e: any) => { setsearchFor(e.target.value) }} placeholder="Type to search" className="m0 ws-9 heightReset noBorderRadius " />
                                    <button className="icon-btn edit ws-2 text-center" onClick={() => splitsListing(activeZone)}>Search </button>
                                </div>
                                <div className="ws-5">
                                    <ul className="nav nav-tabs pull-right">
                                        {
                                            clientZone?.map((valueList: any) => {
                                                return (
                                                    <li className={activeZone?.zoneID == valueList?.zoneID ? "p0 pts pls prs active" : "p0 pts pls prs"} onClick={() => { splitsListing(valueList); }} >
                                                        <span className="pull-left ms ">{valueList?.zoneID}</span>
                                                        <Svg_icon IName={valueList?.zoneID} />
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>

                            <div className="ws-12 text-bold mbl mtl "> Showing ({contractSplitRow}) results </div>

                            <div className="ws-12 allowVscroll allowHscroll">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Track Title</th>
                                            <th>ISRC</th>
                                            <th>Composer/Writer</th>
                                            <th>Publisher</th>
                                            <th>Collector</th>
                                            <th>Operations</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {splitsListingData?.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td>{values.trackName}</td>
                                                    <td>{values.trackSeq}</td>
                                                    <td>{values.writerCodeDisplay}</td>
                                                    <td>{values.publishersDisplay}</td>
                                                    <td>{values.collectedByDisplay}</td>
                                                    <td>  <button className="icon-btn edit pull-right mr" onClick={() => { setSelectSplit(values); allSplit() }} title="LOD">  LOD ({values.publishingSplit})  </button>  </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {contractSplitRow > 10 && <div className="clearfix">
                                {
                                    (() => {
                                        if (contractSplitRow && contractSplitRow > 10) {
                                            return <Pagination onPageChange={paginationContractSplit} totalRow={contractSplitRow} />
                                        }
                                    })()
                                }
                            </div>}

                            {contractSplitRow == 0 && <div className="pLarge mbl ws-12">  <div className="alert">   No results found for these criterias  </div>  </div>}
                        </div>

                    </div>
                    <div className="box-footer pull-right">
                        <button title="Close"                   className="width100 height40 icon-btn delete" onClick={closContactSplit}> Close </button>
                        <button title="Refresh File Details"    className="width100 height40 icon-btn delete pull-right" onClick={splitsListing}><i className="icon-reload"></i></button>
                        <button title="Export"                  className="width100 height40 icon-btn primary pull-right" disabled><i className="icon-download1"></i>  </button>

                    </div>
                </div>
                {
                    (() => {
                        if (allSplitStatus) {
                            return <AllSplitBox allSplitStatus={allSplitStatus} closContactLODSplit={closContactLODSplit} selectSplit={selectSplit} />
                        }
                    })()
                }

            </div>
        </Drawer >
    )
}